import styled from 'styled-components';
import StandardTextField from 'Common/Components/StandardTextField';
import { slideIn } from 'Styles/effects';
import ToggleInput from 'Common/Components/ToggleInput';

export const Wrapper = styled.form`
  display: flex;
  flex-direction: column;
  width: 906px;
  max-height: 58%;
  border-radius: 8px 8px 2px 2px;
  box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.24);
  background-color: ${({ theme }) => theme.backgrounds.editModal};
  border-top: 10px solid #419bf9;
  padding: 39px 0px 52px 35px;
  text-align: left;
  ${slideIn}
 
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
`;
Field.displayName = 'Field';

export const Row = styled.div`
  display: flex;
  ${Field} {
    width: 50%;
  }

  & >:first-child {
    margin-right: 25px;
  }


`;
Row.displayName = 'Row';

export const TextField = styled(StandardTextField)`
  font-weight: 400;
  font-size: 12.5px;
  margin-bottom: 0;
  display: block;
  width: ${(props) => (props.width ? props.width : '100%')};
  
  span {
    user-select: none;
    font-weight: 600;
    margin-bottom: 0;
    color: ${({ theme }) => theme.text.detailModalFields} !important;
    ${({ isRequired }) => isRequired && `
     &:after{
      content: "*";
      color: red;
      margin-left: 5px;
    }
  `}
  }
  input {
    margin-top: 6px;
    ${({ disabled }) => {
      if (!disabled) return null;
      return `
        cursor: not-allowed;
        `;
    }}
  }
  svg {
    top: 34px;
  }

  input:-webkit-autofill {
    background-color: ${({ theme }) => theme.textfield.background} !important;
    color: ${({ theme }) => theme.textfield.text} !important;
    box-shadow: ${({ theme }) => theme.shadows.agentSelectorInScheduler} !important;
    -webkit-text-fill-color: ${({ theme }) => theme.textfield.text} !important;
    }
 
 
`;
TextField.displayName = 'TextField';

export const Password = styled(ToggleInput)`
  width: 405px;
  height: 92px;
  & >:first-child {
    margin-bottom: 5px;
  }

  span {
    user-select: none;
    font-weight: 600;
    color: ${({ theme }) => theme.text.detailModalFields} !important;
    &:after{
      content: "*";
      color: red;
      margin-left: 5px;
    }
  }

  svg {
    top: 40px;
  }
`;
Password.displayName = 'Password';

export const CheckBoxWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 21px;
  margin-left: 29px;
`;
CheckBoxWrapper.displayName = 'CheckBoxWrapper';

export const Label = styled.div`
  margin-left: 8px;
  font-size: 13.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.modalTitle2};
  user-select: none;
`;
Label.displayName = 'Label';

export const Content = styled.div`
  height: calc(100% - 99px);
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  margin-right: 28px;
  padding-right: 9px;
  & >:first-child {
    div {
      width: 50%;
    }
  }
  & >:nth-child(2) {
    & >:first-child {
      width: 405px;
    }
    & >:not(:first-child) {
      width: 187px;
    }
    & >:last-child {
      margin-top: 0;
    }
  }
`;
Content.displayName = 'Content';
